
















import Vue from "vue";
import formatCurrency from "../../helpers/formatCurrency";
export default Vue.extend({
  name: "ConversionRow",
  props: ["item"],
  setup(props, context: any): any {
    return {
      formatCurrency,
      store: context.root.$store.state.store
    };
  }
});
